import React, { useEffect, useMemo, useState } from 'react'
import { Table, Button } from 'reactstrap'
import { UncontrolledTooltip } from 'reactstrap'
import { useAuth } from 'context/AuthProvider';
import { apiMotivoAusenciasService } from 'services/apiMotivoAusenciasService';


const ListaVacacionesSolicitadas = (props) => {
    const { empleado } = useAuth();
    const [motivos, setMotivos] = useState([]);

    useEffect(() => {
      const fetchMotivos = async () => {
        try {
          const response = await apiMotivoAusenciasService.getAllByID(empleado.empresaId);
          const data = await response.json();
          setMotivos(data);
        } catch (e) {
          setMotivos([]);
        }
      };
      fetchMotivos();
    }, [empleado.empresaId]);

    const motivosById = useMemo(
      () => new Map(motivos.map((motivo) => [String(motivo.id), motivo])),
      [motivos]
    );

   //const datos = [{ id: 1, tipo: "V", fecha: "2024/05/01", estado: "Aprovada"}]


    const getTipoComputoLabel = (ausencia) => {
      const motivo = motivosById.get(String(ausencia.descripcion_id));
      if (!motivo?.tipoComputoDias) return "-";
      return motivo.tipoComputoDias === "NATURALES" ? "Naturales" : "Habiles";
    };

    return (
        <>
            <Table  className="align-items-center table-flush" responsive>
                <thead >
                    <tr>
                        <th>Solicitud de:</th>
                        <th>Fecha:</th>
                        <th>fecha resolución:</th>
                        <th>estado:</th>
                        <th>descripcion:</th>
                        <th>Computo:</th>
                        <th>observacion:</th>
                        <th>Dias solicitados:</th>
                    </tr>
                </thead>
                <tbody>
                    {props.datos.map((dato, index) => (
                        <tr key={dato.solicitud.id}>
                            <td>{dato.ausencia.tipo}</td>
                            <td>{dato.solicitud.fechaSolicitud}</td>
                            <td>{dato.solicitud.fechaResolucion}</td>
                            <td>{dato.solicitud.estado}</td>
                            <td>{dato.ausencia.descripcion}</td>
                            <td>{getTipoComputoLabel(dato.ausencia)}</td>
                             <td>
                {dato.ausencia.comentario && (
                  <>
                    <Button
                      className="btn-white"
                      color="default"
                      id={`comentario-${index}` }
                      size="sm"
                      type="button"
                      
                    >
                      Observación
                    </Button>
                    <UncontrolledTooltip
                      target={`comentario-${index}`}
                      placement="top"
                      delay={0}
                      className="custom-tooltip"
                    >
                      {dato.ausencia.comentario}
                    </UncontrolledTooltip>
                  </>
                )}
              </td>
                            <td>{dato.ausencia.fechaDesde} - {dato.ausencia.fechaHasta}</td>
                        </tr>
                    ))}
                </tbody>

            </Table>
        </>
    )
}

export default ListaVacacionesSolicitadas
